"use strict";
//require('select2');
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitHeineken2021 = void 0;
function InitHeineken2021() {
    jQuery(document).ready(function () {
        // YouTube video autoplay after preview play button click
        jQuery('.play-video').click(function () {
            const iFrm = jQuery(this).parents('.o-video-container').children('iframe');
            console.log('iFrm', iFrm);
            if (iFrm.length) {
                const win = window.$(iFrm)[0];
                win.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
        });
    });
}
exports.InitHeineken2021 = InitHeineken2021;
